<template>
	<b-row no-gutters>
		<b-col>
			<b-progress v-if="apartment.progress >= 0" :max="100" class="rounded-0 apartment-progress">
				<div class="w-100 text-center progress-text" :style="{ position: 'absolute' }">
					<h5 class="mt-0 d-none d-lg-block"><b-badge pill variant="dark-transparent">Porcentaje de obra: {{apartment.progress}}%</b-badge></h5>
					<b-badge class="d-lg-none mt-2" pill variant="dark-transparent">Porcentaje de obra: {{apartment.progress}}%</b-badge>
				</div>
				<b-progress-bar variant="gold" :value="apartment.progress" ></b-progress-bar>
			</b-progress>
			<div></div>
			<b-carousel class="apartment-images my-4"  v-if="photos.length > 0" :style="{ textShadow: '0px 0px 2px #000', minHeight: '100px' }" fade controls>
				<b-carousel-slide v-for="(photo, key ) in photos" :key="key" v-bind:style=" { background: 'url('+photo.image_url+')', backgroundSize: 'cover', backgroundPosition: 'center', width: '100%' }"></b-carousel-slide>
			</b-carousel>
			<h5 class="text-muted mt-5">Dirección: <b>{{apartment.project_address}}</b></h5>
			<b-row class="my-5">
				<b-col cols="12" xl="3" class="my-2">
					<div class="d-flex align-items-center mr-2">
						<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
							<div class="symbol-label">
								<span class="svg-icon svg-icon-lg svg-icon-info">
									<font-awesome-icon :icon="['fal', 'bed']" size="lg" />
								</span>
							</div>
						</div>
						<div>
							<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.bedrooms}}</div>
							<div class="font-size-sm text-muted font-weight-bold">Dormitorio{{ apartment.bedrooms > 1 ? "s" : "" }}</div>
						</div>
					</div>
				</b-col>
				<b-col cols="12" xl="3" class="my-2">
					<div class="d-flex align-items-center mr-2">
						<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
							<div class="symbol-label">
								<span class="svg-icon svg-icon-lg svg-icon-info">
									<font-awesome-icon :icon="['fal', 'bath']" size="lg" />
								</span>
							</div>
						</div>
						<div>
							<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.bathrooms}}</div>
							<div class="font-size-sm text-muted font-weight-bold">Baño{{ apartment.bathrooms > 1 ? "s" : "" }}</div>
						</div>
					</div>
				</b-col>
				<b-col cols="6" xl="3" v-if="apartment.parking_lots" class="my-2">
					<div class="d-flex align-items-center mr-2">
						<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
							<div class="symbol-label">
								<span class="svg-icon svg-icon-lg svg-icon-info">
									<font-awesome-icon :icon="['fal', 'car-garage']" size="lg" />
								</span>
							</div>
						</div>
						<div>
							<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.parking_lots}} <small>({{apartment.parking_lots_data}})</small></div>
							<div class="font-size-sm text-muted font-weight-bold">Estacionamiento{{ apartment.parking_lots > 1 ? "s" : "" }}</div>
						</div>
					</div>
				</b-col>
				<b-col cols="12" xl="3" v-if="apartment.cellars" class="my-2">
					<div class="d-flex align-items-center mr-2">
						<div class="symbol symbol-45 symbol-light-gold mr-4 flex-shrink-0">
							<div class="symbol-label">
								<span class="svg-icon svg-icon-lg svg-icon-info">
									<font-awesome-icon :icon="['fal', 'warehouse-alt']" size="lg" />
								</span>
							</div>
						</div>
						<div>
							<div class="h4 text-dark-75 font-weight-bolder mb-0">{{apartment.cellars}} <small>({{apartment.cellars_data}})</small></div>
							<div class="font-size-sm text-muted font-weight-bold">Bodega{{ apartment.cellars > 1 ? "s" : "" }}</div>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-table-simple borderless class="py-3">
				<b-tr>
					<b-td class="px-0">
						<b-alert show variant="light" class="bg-blue-navy h-100 m-0 text-white text-center">
							<div style="font-size: 1.2em">{{new Intl.NumberFormat("es-CL").format(apartment.useful_surface)}}</div>
							<div style="font-size: 65%">Superficie</div>
							<div style="font-size: 65%">Útil</div>
						</b-alert>
					</b-td>
					<b-td class="px-2">
						<b-alert show variant="light" class="bg-blue-navy h-100 m-0 text-white text-center">
							<div style="font-size: 1.2em">{{new Intl.NumberFormat("es-CL").format(apartment.terrace_surface)}}</div>
							<div style="font-size: 65%">Superficie</div>
							<div style="font-size: 65%">Terraza</div>
						</b-alert>
					</b-td>
					<b-td class="px-0">
						<b-alert show variant="light" class="bg-blue-navy h-100 m-0 text-white text-center">
							<div style="font-size: 1.2em">{{new Intl.NumberFormat("es-CL").format(apartment.total_surface)}}</div>
							<div style="font-size: 65%">Superficie</div>
							<div style="font-size: 65%">Total</div>
						</b-alert>
					</b-td>
				</b-tr>
			</b-table-simple>
			<b-table-simple v-if="features.length > 0" borderless class="mt-2">
				<b-tr>
					<b-th colspan="2" style="font-size: 130%">
						Características del edificio
					</b-th>
				</b-tr>
				<b-tr v-for="(feature, key ) in features" :key="key">
					<b-td width="1%" class="align-middle text-center">
						<font-awesome-icon :icon="['fal', setIcon(feature)]" size="2x" class="text-gold" />
					</b-td>
					<b-td>
						{{feature.DESCRIPCION}}
					</b-td>
				</b-tr>
			</b-table-simple>
		</b-col>
	</b-row>
</template>
<script>
export default {
	name: "showApartment",
	props: {
		asset_id: null
	},
	computed: {},
	components:{},
	data() {
		return {
			apartment: {},
			domain: process.env.VUE_APP_CUSTOMER_DOMAIN,
			photos: [],
			features: []
		}
	},
	mounted() {
		this.setApartment();
	},
	methods: {
		setApartment() {
			this.apartment = this.$store.getters.getApartmentById(parseInt(this.asset_id));
			this.setPhotos();
		},
		setPhotos() {
			let self = this;
			this.axios.get("projects/"+this.apartment.project_id+"/get_features", {rut: self.rut}).then(result => {
				self.features = result.data.features;
				self.photos = result.data.images.filter(image => image.ACTIVO);
			}).catch(error => {
				console.log(error)
				self.features = []
			});
		},
		setIcon(feature){
			switch(feature.CATEGORIA){
				case "Areas Verdes":
					return "leaf";
				case "Areas comunes":
					return "dumbbell";
				case "Infraestructura":
					return "building";
				case "Característica departamento":
					return "door-closed";
				case "Espacios Utiles":
					return "garage-car";
				case "Plusvalía":
					return "chart-line";
				default:
					return "building";
			}
			//falLeaf, falDumbbell, falDoorClosed, falChartLine, falGarageCar
		}
	}
};
</script>
<style scoped>
</style> 